import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import {Router} from "react-router-dom";
import {Provider} from "react-redux";
import ReduxThunk from "redux-thunk";
import {createStore, applyMiddleware, compose} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";
import history from './utils/history'
import reducer from "./store/reducer";
import App from "./components/App";



// const store = createStore(reducer, compose(applyMiddleware(ReduxThunk), composeWithDevTools()));
const store = createStore(reducer, compose(applyMiddleware(ReduxThunk)));



ReactDOM.render(
	<Provider store={store}>
		<Router history={history}>
			<App/>
		</Router>
	</Provider>,
	document.getElementById("root")
);